export interface SystemViewModel {
  id: string;
  name: string;
  description: string;
  redirectUri: string;
  homeRedirectUri?: string;
  isPinned?: boolean;
  lastAccessTime?: string;
  groupId?: number | null;
  groupName?: string;
  iconColor?: string;
  initials?: string;
  hostname?: string;
  usageGuide?: string;
}

export interface SystemCategory {
  id: string;
  label: string;
}

export const DEFAULT_SYSTEM_CATEGORIES: SystemCategory[] = [
  { id: 'all', label: 'Tất cả' },
];

export const PINNED_SYSTEMS_STORAGE_KEY = 'sso_pinned_systems';
